import { Capacitor } from '@capacitor/core';

export enum PlatformEnum {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

export const usePlatform = () => {
  const isNativePlatform = Capacitor.isNativePlatform();
  const platform = Capacitor.getPlatform();

  return {
    isNativePlatform,
    isAndroid: platform === PlatformEnum.Android,
    isIos: platform === PlatformEnum.Ios,
    isWeb: platform === PlatformEnum.Web
  };
};
